<template>
  <svg
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 7.41406L14 23.8279L7.77778 7.41406H0Z" fill="#82C8DC" />
    <path d="M20.2222 7.41406L14 23.8279L28 7.41406H20.2222Z" fill="#B4E6F0" />
    <path
      d="M14 7.41325H20.2223L14 0.171875L7.77783 7.41325H14Z"
      fill="#D9FFFF"
    />
    <path
      d="M14 7.41406H7.77783L14 23.8279L20.2223 7.41406H14Z"
      fill="#A0DCE6"
    />
    <path
      d="M6.27586 0.171875L0 7.41325H7.77778L6.27586 0.171875Z"
      fill="#A0DCE6"
    />
    <path d="M28 7.41325L21.7241 0.171875L20.2222 7.41325H28Z" fill="#EBFFFF" />
    <path
      d="M21.7241 0.171875H14L20.2222 7.41325L21.7241 0.171875Z"
      fill="#B4E6F0"
    />
    <path d="M14 0.171875H6.27588L7.7778 7.41325L14 0.171875Z" fill="#B4E6F0" />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
